import Head from 'next/head';
import { stringify } from './stringify';

const JsonLdScript = ({ data, id, scriptKey }) => {
  if (data === null || data === undefined) {
    // Explicitly check for null/undefined
    return null;
  }

  const jsonString = stringify(data);

  return (
    <Head>
      <script
        type="application/ld+json"
        id={id || scriptKey}
        data-testid={id}
        dangerouslySetInnerHTML={{ __html: jsonString }}
        key={scriptKey}
      />
    </Head>
  );
};

export default JsonLdScript;
